import React from 'react';
import styled from 'styled-components';

import { DeviceTypes } from '../../../../utils/getDeviceType';
import {
  HeaderGradientSignUpActionDisplay,
  HeaderSignedInActionsDisplay,
  HeaderSignInActionDisplay,
  HeaderSignInSignUpActionsDisplay,
} from '../../Header.display';

type Props = {
  deviceType: DeviceTypes;
  isUserLoggedIn: boolean;
  isHomeAPage: boolean;
  isScrolled: boolean;
  onNavigateToApp: () => void;
  onClickSignIn: () => void;
  onClickSignUp: () => void;
  onClickDownload: () => void;
};

const AnimatedWrapper = styled.div<{ isVisible: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
`;

const ActionsContainer = styled.div`
  position: relative;
`;

const HeaderActions = (props: Props) => {
  const { isUserLoggedIn, isHomeAPage, isScrolled, onClickSignUp, onNavigateToApp, onClickSignIn } = props;

  return isUserLoggedIn ? (
    <HeaderSignedInActionsDisplay onGoToWebApp={onNavigateToApp} />
  ) : (
    <>
      {isHomeAPage ? (
        <ActionsContainer>
          <AnimatedWrapper isVisible={isScrolled}>
            <HeaderGradientSignUpActionDisplay onClickSignUp={onClickSignUp} />
          </AnimatedWrapper>
          <AnimatedWrapper isVisible={!isScrolled}>
            <HeaderSignInActionDisplay onClickSignIn={onClickSignIn} />
          </AnimatedWrapper>
        </ActionsContainer>
      ): (
        <HeaderSignInSignUpActionsDisplay onClickSignIn={onClickSignIn} onClickSignUp={onClickSignUp} />
      )}

      
    </>
  );
};

export default HeaderActions;
